import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface CurrentUserBalance {
  id: number;
  amount: number;
  credit: number;
  onHold: number;
  currency: string;
  totalActiveBonus: number;
  wagerBonus: number;
  dailyBonus: number;
  hourlyBonus: number;
}

const GET_CURRENT_USER_BALANCE = gql`
  query GetCurrentUserBalance {
    getCurrentUserBalance {
      id
      amount
      credit
      onHold
      currency
      totalActiveBonus
      wagerBonus
      dailyBonus
      hourlyBonus
    }
  }
`;

export const getCurrentUserBalance = async (): Promise<CurrentUserBalance> => {
  try {
    const { data } = await apolloClient.query<{
      getCurrentUserBalance: CurrentUserBalance;
    }>({
      query: GET_CURRENT_USER_BALANCE,
      fetchPolicy: 'network-only',
    });
    return data.getCurrentUserBalance;
  } catch (error) {
    console.error('❌ Error fetching current user balance:', error);
    throw error;
  }
};
